var exports = {
  "k": "xfd349460--2f8ce1--container",
  "_": "xfd349460--2f8ce1--img",
};

module.exports = exports;
